import React from 'react'
import "./L.css"

function Round() {
  return (
    <> 
    
     <div class='body'>
  <span>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </span>
  <div class='base'>
    <span></span>
    <div class='face'></div>
  </div>
</div>
<div class='longfazers'>
  <span></span>
  <span></span>
  <span></span>
  <span></span>
</div>
<h1 style={{color:'white'}}>LOADING...</h1>

  </>
  )
}

export default Round